import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ColumnDef } from '@tanstack/react-table';

import { ColumnHeader } from '@/components/table/column-header';
import { SelectableRow } from '@/components/table/selectable-row';
import { Checkbox } from '@/components/ui/checkbox';
import {
  CellValue,
  ShipVisit,
} from '@/routes/(app)/(scenarios)/(create)/types';

export const useShipmentTableColumns = () => {
  const { t } = useTranslation();

  return useMemo<Array<ColumnDef<ShipVisit, CellValue>>>(
    () => [
      {
        id: 'select',
        enableSorting: false,
        header: ({ table }) => (
          <span className='p-1'>
            <Checkbox
              checked={
                table.getIsAllPageRowsSelected() ||
                (table.getIsSomePageRowsSelected() && 'indeterminate')
              }
              onCheckedChange={(checked) => {
                table.toggleAllPageRowsSelected(checked === true);
              }}
            />
          </span>
        ),
        cell: ({ row }) => <SelectableRow row={row} />,
      },
      {
        accessorKey: 'id',
        header: t('shipVisits.table.id'),
        meta: { inputType: 'text', readOnly: true },
      },
      {
        accessorKey: 'ship_id',
        header: t('shipVisits.table.ship_id'),
        meta: { inputType: 'text', readOnly: true },
      },
      {
        accessorKey: 'shipping_line_id',
        header: t('shipVisits.table.shipping_line_id'),
        meta: { inputType: 'text', readOnly: true },
      },
      {
        accessorKey: 'arrival_time',
        header: ({ column }) => (
          <ColumnHeader
            column={column}
            enableSorting={true}
            title={t('shipVisits.table.arrival_time')}
          />
        ),
        meta: { inputType: 'datetime-local' },
      },
      {
        accessorKey: 'departure_time',
        header: t('shipVisits.table.departure_time'),
        meta: { inputType: 'datetime-local' },
      },
      {
        accessorKey: 'bollard_fore',
        header: t('shipVisits.table.bollard_fore'),
        meta: { inputType: 'number', readOnly: true },
      },
      {
        accessorKey: 'bollard_aft',
        header: t('shipVisits.table.bollard_aft'),
        meta: { inputType: 'number', readOnly: true },
      },
      {
        accessorKey: 'n_moves_discharge',
        header: t('shipVisits.table.n_moves_discharge'),
        meta: { inputType: 'number' },
      },
      {
        accessorKey: 'n_moves_load',
        header: t('shipVisits.table.n_moves_load'),
        meta: { inputType: 'number' },
      },
    ],
    [t]
  );
};
